<template>
	<reqsType :baseUrlpath="baseUrlpath" :reqType="reqType"></reqsType>
</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	import reqsType from '@/components/reqsType.vue'
	export default {
		name: '本地餐厅',
		metaInfo: {
			title: '中东华人宝-本地餐厅',
			meta: [{
					name: 'keyWords',
					content: '本地餐厅'
				},
				{
					name: 'description',
					content: '传统中餐,烧烤,海鲜,火锅,阿拉伯餐,西餐,酒吧,茶馆/咖啡厅, 蛋糕店/奶茶店,菜单,新品推荐,特惠套餐,满减活动,打折促销,赠送礼品,环境'
				}
			]
		},
		components: {
			reqsType
		},
		data() {
			return {
				baseUrlpath: '',
				reqType: '12'
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			var inchina = localStorage.getItem('inChina');
			if(inchina == '1'){
				this.baseUrlpath = this.baseUrlCN;
			}
		},
		methods: {}
	}
</script>

<style>
</style>